angular.module("UserSettingsApp")
.component('userSettingsCard', {
    templateUrl: '/static/assets/khapps/settings_v2/general/user_settings/user-settings-card.component.html',
    controller: function(UserSettingsService) {
        this.showEditDialog = function(event) {
            UserSettingsService.showEditDialog(event);
        }
    }
});